import React from "react";
import { makeThemedStyles } from "@qpr/client-api-base/viewcomponents/utils";

const useLeftMenuPositionStyles = makeThemedStyles(
  "LeftMenuPosition",
  (theme) => ({
    root: {
      position: "fixed",
      left: "0px",
      top: "200px",
      zIndex: 1000,
      "div[dir=rtl] & ": {
        left: "unset",
        right: "0px",
      },
    },
  })
);
const LeftMenuPosition = (
  props: React.PropsWithChildren<{
    gap?: string;
  }>
) => {
  const styles = useLeftMenuPositionStyles();
  return (
    <div
      className={styles.root}
      style={{
        gap: props.gap,
      }}
    >
      {props.children}
    </div>
  );
};

export default LeftMenuPosition;
